export default () => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  firstName: {
    width: '100%',
    maxWidth: 400,
  },
  lastName: {
    width: '100%',
    maxWidth: 600,
  },
  email: {
    width: '100%',
    maxWidth: 600,
  },
  avatarField: {
    width: '100%',
    maxWidth: 400,
  },
  actionButton: { marginLeft: 'auto' },
  avatarIcon: {
    float: 'right',
    marginBottom: 5,
  },
  removeAvatarButton: { float: 'right' },
  profileImageContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  flex: { flex: 1 },
});
